export const text = {
  title: 'Gardens',
  sectionTitle: 'Gardens',
  newGarden: '+ New Garden',
  emptyTitle: 'No gardens yet',
  emptyHint: 'Click "+ New Garden" to create your first garden',
  createDialogTitle: 'Create New Garden',
  createDialogDescription: 'Give your new garden a name. You can change this later.',
  gardenNameLabel: 'Garden Name',
  gardenNamePlaceholder: 'Enter garden name...',
  createGarden: 'Create Garden',
  editDialogTitle: 'Rename Garden',
  editDialogDescription: 'Update the name of your garden.',
  saveChanges: 'Save Changes',
  deleteDialogTitle: 'Delete Garden?',
  deleteGarden: 'Delete Garden',
  renameGarden: 'Rename garden',
  duplicateGarden: 'Duplicate garden',
  viewGarden: 'View garden',
  viewGardenMobileUnavailable: 'The garden planner is not available on mobile yet.',
  cannotDeleteLastGarden: 'Cannot delete last garden',
  createError: 'Could not create garden. Please try again.',
  renameError: 'Could not rename garden. Please try again.',
  deleteError: 'Could not delete garden. Please try again.',
  duplicateError: 'Could not duplicate garden. Please try again.',
  deleteDialogDescription: (name: string) =>
    `Are you sure you want to delete "${name}"? This action cannot be undone and all plants in this garden will be lost.`,
  gardenSummary: (rows: number, columns: number, plantCount: number) =>
    `${rows} × ${columns} cells • ${plantCount} plants`,
};
